import React from 'react';
import classNames from 'classnames';
import View from '@loggi/ui/components/view';

function getColElement(className, classList, otherProps, children) {
  const classes = classNames(classList, className);
  return (
    <View className={classes} {...otherProps}>
      {children}
    </View>
  );
}

export { getColElement };
